export default {
  $vuetify: {
    badge: 'Badge',
    close: 'Close',
    dataIterator: {
      noResultsText: 'No matching records found',
      loadingText: 'Loading items...',
    },
    dataTable: {
      itemsPerPageText: 'Rows per page:',
      ariaLabel: {
        sortDescending: 'Sorted descending.',
        sortAscending: 'Sorted ascending.',
        sortNone: 'Not sorted.',
        activateNone: 'Activate to remove sorting.',
        activateDescending: 'Activate to sort descending.',
        activateAscending: 'Activate to sort ascending.',
      },
      sortBy: 'Sort by',
    },
    dataFooter: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}',
    },
    datePicker: {
      itemsSelected: '{0} selected',
      nextMonthAriaLabel: 'Next month',
      nextYearAriaLabel: 'Next year',
      prevMonthAriaLabel: 'Previous month',
      prevYearAriaLabel: 'Previous year',
    },
    noDataText: 'No data available',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual',
      ariaLabel: {
        delimiter: 'Carousel slide {0} of {1}',
      },
    },
    calendar: {
      moreEvents: '{0} more',
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Pagination Navigation',
        next: 'Next page',
        previous: 'Previous page',
        page: 'Goto Page {0}',
        currentPage: 'Current Page, Page {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: 'Rating {0} of {1}',
      },
    },
  },
  errors: {
    login: {
      401: "Invalid credentials",
      403: "Invalid credentials",
      500: "An error has occurred, please try to log in again later.",
      503: "Currently uploading an update, please try to log in again later.",
    }
  },
  navigation: {
    selectAll: "Select all",
    route: {
      forms: "Forms",
      users: "Sessions",
      tenants: "Institutions",
      repliesLog: "Replies Logs"
    }
  },
  login: {
    actions: {
      forgotPassword: "Did you forget your password?",
      login: "Login",
      backToLogin: "Back to Login",
      recoverPassword: "Recover password"
    },
    form: {
      fields: {
        username: "Email",
        password: "Password",
        email: "Email"
      },
      validations: {
        username: {
          required: "You must enter the username"
        },
        password: {
          required: "You must enter the password"
        }
      }
    }
  },
  users: {
    title: "Sessions",
    actions: {
      add: "Add",
    },
    headers: {
      id: "Id",
      email: "Email",
      name: "Name",
      tenant: "Organization",
      title: "Position",
      lastLogin: "Last login",
      role: "Role",
      actions: "Actions"
    },
    form: {
      add: "New User",
      roleChange: "Change Role",
      fields: {
        givenName: "Given Name",
        familyName: "Family Name",
        email: "Email",
        username: "User",
        tenant: "Institution",
        role: "Role",
      },
      actions: {
        save: "Save",
        cancel: "Cancel"
      },
      roles: {
        admin: "Admin",
        maintainer: "Maintainer",
        user: "User"
      }
    }
  },
  tenants: {
    title: "Institutions",
    actions: {
      add: "Add"
    },
    headers: {
      id: "Id",
      name: "Name",
      description: "Description",
      contact_person: "Contact Name",
      actions: "Actions"
    },
    form: {
      add: "New Institution",
      fields: {
        name: "Name",
        description: "Description",
        contactPerson: "Contact Name",
      },
      actions: {
        save: "Save",
        cancel: "Cancel"
      }
    }
  },
  replyLogs: {
    title: "Replies",
    actions: {
      create: "Created",
      edit: "Edited",
      title: {
        edit: "Edited Questions",
        create: "Answered Questions"
      }
    },
    headers: {
      formName: "Form",
      id: "ID",
      userName: "User",
      tenantName: "Tenant",
      createdAt: "Date",
      action: "Action"
    },
  },
  forms: {
    title: "Forms",
    noDataMessage: "There are no forms available",
    submitted: "Your response has been recorded.",
    closedEdit: "The answer has not been edited, you can make a new answer with the following button",
    copyLink: "Link copied to clipboard.",
    delete: {
      title: "Delete form",
      message: "Are you sure you want to delete form?",
      action: "Delete"
    },
    actions: {
      add: "Add",
      organizations: "Organizations",
      otherResponse: "Other answer",
      edit: "Edit",
      delete: "Delete",
      submit: "Submit new response",
      replies: "Replies",
      downloadExcel: "Download Data",
      shareLink: "Share submit link",
      shareLinkShort: "Share link",
      downloadJson: "Download Json",
      goToHome: "Back to Forms",
    },
    tabs: {
      formSettings: "Settings",
      newForm: "New Form",
      preview: "Preview"
    },
    headers: {
      answers: "Answers",
      lastUpdate: "Last update",
    },
    defaultData: {
      id: {
        text: "ID"
      },
      name: {
        text: "Given Name"
      }
    },
    replies: {
      title: "Replies",
      headers: {
        id: "ID",
        createdAt: "Created At",
        updatedAt: "Updated At",
        createdBy: "Created By",
        actions: "Actions",
      }
    },
    downloadExcel: {
      title: "Select the organization from which the data will be obtained",
      confirmTitle: "Are you sure to download the data for this tenant?",
      tenants: "Institutions",
      selectAll: "Select All",
      actions: {
        download: "Download Excel"
      }
    },
    form: {
      add: "New Form",
      groups: "Groups Selection",
      sendToJoin: "Save and Send to Join",
      next: "Next",
      noGroups: "You have no groups registered in Join. Create a group in Join and try again.",
      sendReplyTo: "Are you sure to send the answer to this group?",
      sendEditReplyTo: "Are you sure to send the answer to this group?",
      save: "Save",
      loadJSON: "Load JSON",
      edited: "Edited",
      sendEdit: "Send submit",
      imageLoaded: "Image",
      actions: {
        save: "Save",
        cancel: "Cancel",
        newQuestion: "New Question",
        search: "Search",
        clearForm: "Clear Form",
        clearSection: "Clear Section",
        copy: "Copy question",
        delete: "Delete question",
        uploadImage: "Upload image",
        deleteImage: "Delete image",
        closeEdit: "Close"
      },
      default: {
        untitledForm: "Untitled Form",
        option1: "Option 1",
      },
      confirmation: {
        deleteMandatory: "Also remove required fields. (only editable)",
        section: {
          title: "Clean Section",
          description: "Are you sure to clear the current section? The data entered cannot be retrieved afterwards.",
          action: "Clean Section"
        },
        form: {
          title: "Clean Form",
          description: "Are you sure you clean the entire form? The data entered cannot be retrieved afterwards.",
          action: "Clean Form"
        },
      },
      questions: {
        shortAnswer: "Short Answer",
        paragraph: "Paragraph",
        multipleChoice: "Multiple Choice",
        checkboxes: "Multiple Answers",
        dropdown: "Select Field",
        linearScale: "Linear Scale",
        date: "Date Picker",
        time: "Time picker",
        section: "Section"
      },
      fields: {
        title: "Title",
        description: "Description",
        question: "Question",
        shortAnswerText: "Short answer text",
        longAnswerText: "Long answer text",
        optionText: "Option's text",
        addOption: "Add Option",
        from: "From",
        to: "To",
        labelFrom: "Label From",
        labelTo: "Label To",
        date: "Date",
        time: "Time",
        required: "Required",
        organizations: "Organizations",
        photo: "Form Image",
        section: "Section",
        validations: "Validations",
        score: "Score Form",
        scoreRuleStatus: "Score Rules",
        scoreLabel: "Score",
        editable: "Editable",
        image: "Image"
      },
      preview: {
        selectGroup: "Select Group",
        yourAnswer: "Answer",
        chooseOption: "Choose an option",
        pickDate: "Choose a date",
        pickTime: "Choose a time",
        submit: "Submit",
        edit: "Edit",
        clearForm: "Clear Form",
        totalScore: "Total Score"
      },
      reply: {
        editUrl: "Edit answer"
      },
      scoreRules: {
        headers: {
          value: "Value",
          operator: "Operator",
          title: 'Title',
          description: "Description",
        },
        actions: {
          addRule: "Add another rule"
        }
      },
      validations: {
        default: "This is a required question.",
        required: "This field is required.",
        email: "You must enter a valid email.",
        phone: "You must enter a valid phone number.",
        rut: "You must enter a valid rut.",
        scoreValidNumber: "The score must be between 0 and 9",
        fileSizeError: "The file must be at most 5Mb.",
        fileUnsupportedFile: "The type of file given is not supported.",
        noTenantsSelected: "You need to assign this form to at least one tenant.",
        options: {
          email: "Email",
          phone: "Phone Number",
          rut: "Rut",
          regex: "Regular Expression",
        },
      }
    }
  },
}
